export default __webpack_public_path__ + "static/media/Jaffna-Diocese.bf138282.png";